import { openBlock as e, createElementBlock as c, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 13"
}, n = /* @__PURE__ */ t("path", {
  fill: "currentColor",
  d: "M16.71 3.102h-1.458a.32.32 0 0 0-.217.087c-.466-.743-.948-1.339-1.322-1.713C12.41.175 4.603.175 3.3 1.476c-.373.374-.852.965-1.316 1.704a.3.3 0 0 0-.2-.076H.325A.327.327 0 0 0 0 3.429v.657a.41.41 0 0 0 .319.386l.885.17C.44 6.344-.01 8.464.698 10.588v1.26c0 .36.09.651.203.651h1.667c.113 0 .204-.29.204-.65v-1.031c1.495.143 3.612.299 5.734.299 2.103 0 4.243-.154 5.736-.296v1.027c0 .36.09.651.203.651h1.667c.112 0 .203-.29.203-.65l-.001-1.262c.707-2.121.258-4.24-.505-5.944l.906-.172a.41.41 0 0 0 .319-.387v-.657a.325.325 0 0 0-.323-.325ZM2.732 8.391a1.18 1.18 0 0 1 0-2.359 1.18 1.18 0 0 1 0 2.359M1.74 5.013c.625-1.43 1.495-2.548 2.022-3.077.38-.38 2.174-.785 4.745-.785 2.573 0 4.365.405 4.746.786.527.527 1.396 1.646 2.021 3.076-1.387.154-4.09-.201-6.766-.201s-5.379.355-6.768.201m12.542 3.378a1.18 1.18 0 0 1 0-2.359 1.18 1.18 0 0 1 0 2.359"
}, null, -1), l = [
  n
];
function r(a, s) {
  return e(), c("svg", o, [...l]);
}
const d = { render: r };
export {
  d as default,
  r as render
};
